export var EMedia;
(function (EMedia) {
    EMedia["IMAGE"] = "images";
    EMedia["IMAGE_360"] = "three_sixty_image";
    EMedia["AUDIO"] = "audio";
    EMedia["VIDEO"] = "video";
    EMedia["VIDEO_360"] = "three_sixty_video";
    EMedia["MODEL_3D_BASE"] = "three_d_model_base";
    EMedia["IMMERSIVE_MODEL"] = "immersive_model";
    EMedia["TEXT"] = "text";
    EMedia["DOCUMENT"] = "document";
    EMedia["PASSTHROUGH"] = "passthrough";
})(EMedia || (EMedia = {}));
